import(/* webpackMode: "eager" */ "/deploy-cf/components/site-header.tsx")